/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontCallButton_viewer$ref = any;
export type StorefrontSocial_viewer$ref = any;
export type StorefrontSocial_viewer = {
    readonly " $fragmentRefs": StorefrontCallButton_viewer$ref;
    readonly " $refType": StorefrontSocial_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontSocial_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontCallButton_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '5d99f3cde3423e815e63e88579c0b4c1';
export default node;
